import React from "react";
import { Handle, Position, type NodeProps } from "reactflow";

import Group2417 from "../../assets/images/svg/Group2417";
import style from "./CustomNode.module.scss";

type NodeData = {
  label: string;
  status: boolean;
  isSelected: boolean;
  setShowJobTaskPage: (next: boolean) => void;
  showJobTaskPage: boolean;
  connected: boolean;
  setShowPlugInModal?: (next: boolean) => void;
  setModalDependecyChange: (next: boolean) => void;
  modelId?: number;
  subject_area?: string;
};

export const CustomNode: React.FC<NodeProps<NodeData>> = ({ data }) => {
  const truncatedLabel =
    data.label.length > 26 ? `${data.label.slice(0, 26)}…` : data.label;
  const subjectArea =
    (data.subject_area && data.subject_area.trim()) || "Untitled subject";

  const handleViewDetails = () => {
    if (typeof data.modelId === "number") {
      localStorage.setItem("last_ensemble_model_id", String(data.modelId));
    }
    data.setShowJobTaskPage(true);
    data.setModalDependecyChange(false);
  };

  const handleViewJobs = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    if (typeof data.setShowPlugInModal === "function") {
      data.setShowPlugInModal(true);
    }
  };

  return (
    <div
      className={`${style.nodeShell} ${
        data.isSelected ? style.nodeShellSelected : ""
      }`}
    >
      <Handle
        type="target"
        position={Position.Left}
        className={`${style.handle} ${style.handleLeft}`}
      />
      <div className={style.nodeBody}>
        <div className={style.nodeIcon}>
          <Group2417 height="64" width="64" />
        </div>
        <div className={style.meta}>
          <p className={style.subject}>{subjectArea}</p>
          <h3 className={style.title}>{truncatedLabel}</h3>
        </div>
        {data.isSelected && (
          <div className={style.actions}>
            {!data.showJobTaskPage ? (
              <button
                type="button"
                className={style.primaryCta}
                onClick={handleViewDetails}
              >
                View Data Model
              </button>
            ) : (
              <button
                type="button"
                className={`${style.primaryCta} ${style.secondaryCta}`}
                onClick={handleViewJobs}
              >
                View Job Task
              </button>
            )}
          </div>
        )}
      </div>
      <Handle
        type="source"
        position={Position.Right}
        className={`${style.handle} ${style.handleRight}`}
      />
    </div>
  );
};

export default CustomNode;
